import JSZip from "jszip";
import { pushDialog } from ".";
import { fetchApi } from "../../config/fetchConfig";
import I18n from "../../I18n";
import { apiDomain } from "../../environmentVariables";

import dompurify from "dompurify";
const { Buffer } = require("buffer");

const uploadStart = (files) => ({
    type: "UPLOAD_FILE_START",
    payload: { files: files },
});

const uploadProgress = (filename, progress) => ({
    type: "UPLOAD_FILE_PROGRESS",
    payload: { file: filename, progress },
});
const uploadFailed = (filename, message) => ({
    type: "UPLOAD_FILE_FAILED",
    payload: { file: filename, message },
});

const deleteError = (data) => {
    return {
        type: "DELETE_ERROR",
        payload: {
            data,
        },
    };
};

const openUpload = (data) => {
    return {
        type: "OPEN",
        payload: {
            data,
        },
    };
};
function toBuffer(arr) {
    return ArrayBuffer.isView(arr)
        ? // To avoid a copy, use the typed array's underlying ArrayBuffer to back
          // new Buffer, respecting the "view", i.e. byteOffset and byteLength
          Buffer.from(arr.buffer, arr.byteOffset, arr.byteLength)
        : // Pass through all other types to `Buffer.from`
          Buffer.from(arr);
}

const prepareFile = (file) => {
    return new Promise((resolve, reject) => {
        if (file.type === "text/xml") {
            const zip = new JSZip();
            const fileReader = new FileReader();

            fileReader.readAsArrayBuffer(file);

            fileReader.onloadend = function loaded(event) {
                let result = event.target.result;
                if (result instanceof ArrayBuffer) {
                    result = toBuffer(new Uint8Array(event.target.result));
                    const zipFileName = file.name.replace(/.xml/gi, ".zip");

                    zip.file(file.name, result);

                    zip.generateAsync({ type: "blob" }).then(function (content) {
                        const zippedFile = new File([content], zipFileName);
                        resolve(zippedFile);
                    });
                } else {
                    reject(new Error("Invalid File"));
                }
            };
            fileReader.onerror = function (error) {
                reject(error);
            };
        } else {
            resolve(file);
        }
    });
};

let requests = [];

export const uploadAction = (projectId, files, showTermsUpload, reload) => (dispatch) => {
    if (!projectId && !files) {
        return dispatch(openUpload(true));
    }

    if (requests && requests.length) {
        requests.forEach((request) => {
            request.abort();
        });
        requests = [];
    }

    if (!projectId || !files) {
        return;
    }

    if (showTermsUpload) {
        dispatch(
            pushDialog("ConfirmDialog", I18n.translate`Upload file`, {
                title: I18n.translate`This tool is not intended for the submission or upload of any Personal Data. No Personal Data is permitted to be submitted or uploaded! The Provider does not accept or require processing of any Personal Data for the use of this tool. By clicking 'Confirm' below You agree that any and all data and information uploaded is Your sole responsibility and You further represent and warrant that You have all necessary right, title, interest and consent necessary to provide such data to the Provider. Should You include any Personal Data in the submission or upload of data through this tool, You represent and warrant that You will bear all responsibility and liability related to the disclosure of such Personal Data and that You will comply with any laws applicable to the disclosure of Personal Data, including providing notices to or obtaining permission from third parties to allow sharing of their Personal Data through this tool. Please confirm Your acceptance and agreement to these statements by clicking 'Confirm' below.`,
                text: (files || []).map((elem) => elem.name),
                promptText: I18n.translate`Do you confirm the file(s) being uploaded do not contain any Personal Data or have been correctly anonymized to remove any reference or inclusion of Personal Data, and that You accept the terms stated above?`,
            }),
        ).then(() => {
            uploadFilesRequest(projectId, files, dispatch, reload);
        });
    } else {
        return uploadFilesRequest(projectId, files, dispatch, reload);
    }
};

const uploadFilesRequest = (projectId, files, dispatch, reload) => {
    const uploads = files.map((file) => {
        return new Promise((resolve, reject) => {
            const request = new XMLHttpRequest();
            request.addEventListener("load", (e) => {
                resolve();
            });
            request.addEventListener("progress", (e) => {
                if (e.lengthComputable) {
                    const progress = e.loaded / e.total;
                    dispatch(uploadProgress(file.name, progress));
                }
            });
            request.upload &&
                request.upload.addEventListener("progress", (e) => {
                    if (e.lengthComputable) {
                        const progress = e.loaded / e.total;
                        dispatch(uploadProgress(file.name, progress));
                    }
                });

            request.onreadystatechange = () => {
                if (request.readyState === 4) {
                    if (request.status === 200) {
                        return;
                    } else if (request.status === 413) {
                        dispatch(uploadFailed(file.name, "Error: File too large"));
                    } else if (request.status === 0) {
                        dispatch(uploadFailed(file.name, "Error: Connection doesn't exist!"));
                    } else if (request.status === 400) {
                        dispatch(uploadFailed(file.name, "Error: " + request.responseText));
                    } else {
                        dispatch(uploadFailed(file.name, "Somethings Went Wrong"));
                    }
                }
            };

            requests.push(request);

            const data = new FormData();
            dispatch(uploadStart(files));
            prepareFile(file)
                .then((resultFile) => {
                    data.append("file", resultFile);
                    data.append("projectSourceId", projectId);

                    request.open("POST", apiDomain + "/api/upload", true);
                    if (apiDomain) {
                        request.withCredentials = true;
                    }
                    request.send(data);
                })
                .catch((e) => {
                    dispatch(uploadFailed(file.name, e.message));
                });
        });
    });
    return Promise.all(uploads).then(() => reload && reload());
};

export const setDataFileStatusAction =
    ({ fiscalYear, projectId, files, status }) =>
    (dispatch, getState) => {
        const queriesBody = {
            query: `mutation($p:String!,$d:[Int!]!,$s:String!){set_data_file_status(projectId:$p,dataFileIds:$d,dataFileStatus:$s)}`,
            variables: {
                p: projectId,
                f: fiscalYear,
                d: files,
                s: status, // deleted or imported
            },
        };

        return fetchApi("/graphql", queriesBody, {}, { dispatch, user: getState()?.user })
            .then((res) => res.json().catch(() => ({})))
            .then((res) => {
                const data = res.data || {};

                if (data && data.set_data_file_status) {
                    return true;
                } else {
                    dispatch(deleteError("Unknown"));
                    throw new Error("Unknown");
                }
            })
            .catch((e) => {
                throw new Error(e.message);
            });
    };

export const deleteFilePermanentlyAction =
    ({ fiscalYear, projectId, files, userId }) =>
    (dispatch, getState) => {
        const queriesBody = {
            query: `mutation($p:String!,$f:String!,$d:[Int!]!,$u:Int!){delete_file_permanently(projectId:$p,fiscalYear:$f,dataFileIds:$d,userId:$u)}`,
            variables: {
                p: projectId,
                f: fiscalYear,
                d: files,
                u: userId,
            },
        };

        return fetchApi("/graphql", queriesBody, {}, { dispatch, user: getState()?.user })
            .then((res) => res.json().catch(() => ({})))
            .then((res) => {
                const data = res.data || {};

                if (data && data.delete_file_permanently) {
                    return true;
                } else {
                    dispatch(deleteError("Unknown"));
                    throw new Error("Unknown");
                }
            })
            .catch((e) => {
                throw new Error(e.message);
            });
    };

export const deleteFilePermanentlyByPathAction =
    ({ fileLocation, generatorId }) =>
    (dispatch, getState) => {
        const queriesBody = {
            query: `mutation($p:String!,$i:String!){delete_file_permanently_by_path(fileLocation:$p, generatorId:$i)}`,
            variables: {
                p: fileLocation || "",
                i: generatorId,
            },
        };

        return fetchApi("/graphql", queriesBody, {}, { dispatch, user: getState()?.user })
            .then((res) => res.json().catch(() => ({})))
            .then((res) => {
                const data = res.data || {};

                if (data && data.delete_file_permanently_by_path) {
                    return true;
                } else {
                    dispatch(deleteError("Unknown"));
                    throw new Error("Unknown");
                }
            })
            .catch((e) => {
                throw new Error(e.message);
            });
    };
//TODO: CHECK IF CAN REMOVE THIS
export const hideFileAction =
    ({ fileId }) =>
    (dispatch, getState) => {
        const queriesBody = {
            query: `mutation($p:Int!){hide_file(fileId:$p)}`,
            variables: {
                p: fileId,
            },
        };

        return fetchApi("/graphql", queriesBody, {}, { dispatch, user: getState()?.user })
            .then((res) => res.json().catch(() => ({})))
            .then((res) => {
                const data = res.data || {};

                if (data && data.hide_file) {
                    return true;
                } else {
                    dispatch(deleteError("Unknown"));
                    throw new Error("Unknown");
                }
            })
            .catch((e) => {
                throw new Error(e.message);
            });
    };

export const downloadFilesAction =
    ({ files }) =>
    (dispatch, getState) => {
        for (const file of files) {
            const { id, fileLocation } = file;
            fetchApi(
                "/api/download_file",
                { filePath: fileLocation },
                {},
                { dispatch, user: getState()?.user },
            )
                .then((t) => {
                    return t.blob().then((b) => {
                        if (b && b.size > 20) {
                            const slipttedRowValue = fileLocation.split("/");
                            const fileName = slipttedRowValue[slipttedRowValue.length - 1];
                            const a = document.createElement("a");
                            a.href = dompurify.sanitize(URL.createObjectURL(b));
                            a.setAttribute("download", fileName);
                            document.body.appendChild(a);
                            a.click();
                            document.body.removeChild(a);
                        } else {
                            if (document.getElementById(`tooltip_${id}`) !== null) {
                                document.getElementById(`tooltip_${id}`).style.visibility =
                                    "visible";
                                setTimeout(function () {
                                    if (document.getElementById(`tooltip_${id}`) !== null) {
                                        document.getElementById(`tooltip_${id}`).style.visibility =
                                            "hidden";
                                    }
                                }, 3000);
                            }
                        }
                    });
                })
                .catch((e) => {
                    throw new Error(e.message);
                });
        }
        return;
    };

export const downloadFileAction =
    ({ filePath, id }) =>
    (dispatch, getState) => {
        return fetchApi(
            "/api/download_file",
            { filePath: filePath },
            {},
            { dispatch, user: getState()?.user },
        )
            .then((t) => {
                return t.blob().then((b) => {
                    if (b && b.size > 20 && filePath) {
                        const slipttedRowValue = filePath.split("/");
                        const fileName = slipttedRowValue[slipttedRowValue.length - 1];
                        const a = document.createElement("a");
                        a.href = dompurify.sanitize(URL.createObjectURL(b));
                        a.setAttribute("download", fileName);
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                    } else {
                        document.getElementById(id).style.visibility = "visible";
                        setTimeout(function () {
                            document.getElementById(id).style.visibility = "hidden";
                        }, 3000);
                        console.error("empty file");
                    }
                });
            })
            .catch((e) => {
                throw new Error(e.message);
            });
    };

export const deleteInvalidFilePermanentlyAction =
    ({ projectId, fileId, userId }) =>
    (dispatch, getState) => {
        const queriesBody = {
            query: `mutation($p:String!,$d:String!,$u:Int!){delete_invalid_file_permanently(projectId:$p,fileId:$d,userId:$u)}`,
            variables: {
                p: projectId,
                d: fileId,
                u: userId,
            },
        };

        return fetchApi("/graphql", queriesBody, {}, { dispatch, user: getState()?.user })
            .then((res) => res.json().catch(() => ({})))
            .then((res) => {
                const data = res.data || {};

                if (data && data.delete_invalid_file_permanently) {
                    window.location.reload();
                } else {
                    dispatch(deleteError("Unknown"));
                    throw new Error("Unknown");
                }
            })
            .catch((e) => {
                throw new Error(e.message);
            });
    };

export const reprocessFileAction =
    ({ files, projectId }) =>
    (dispatch, getState) => {
        const queriesBody = {
            query: `mutation($p:String!,$d:[Int!]!){nc_reprocess_file(projectId:$p,fileIds:$d)}`,
            variables: {
                p: projectId,
                d: files,
            },
        };

        return fetchApi("/graphql", queriesBody, {}, { dispatch, user: getState()?.user })
            .then((res) => res.json().catch(() => ({})))
            .then((res) => {
                const data = res.data || {};

                if (data && data.nc_reprocess_file) {
                    return true;
                } else {
                    dispatch(deleteError("Unknown"));
                    throw new Error("Unknown");
                }
            })
            .catch((e) => {
                throw new Error(e.message);
            });
    };

export const reprocessRepositoryAction =
    ({ fiscalYear, projectId, fileType, userId }) =>
    (dispatch, getState) => {
        const queriesBody = {
            query: `mutation($p:String!,$f:String!,$t:String!,$u:Int!){reprocess_repository(projectId:$p,fiscalYear:$f,fileType:$t,userId:$u)}`,
            variables: {
                p: projectId,
                f: fiscalYear,
                t: fileType,
                u: userId,
            },
        };

        return fetchApi("/graphql", queriesBody, {}, { dispatch, user: getState()?.user });
    };

export const requestDataForOrganizationsAction =
    ({ fiscalYear, organizationId, userId }) =>
    (dispatch, getState) => {
        const queriesBody = {
            query: `mutation($o:String!,$u:Int!,$f:String!){request_data_for_organization(organizationId:$o,userId:$u,fiscalYear:$f)}`,
            variables: {
                o: organizationId,
                u: userId,
                f: fiscalYear,
            },
        };

        return fetchApi("/graphql", queriesBody, {}, { dispatch, user: getState()?.user });
    };

export const saveWorkerAssociationPackageAction =
    ({ entity, packageId, selectItems, removedItems }) =>
    (dispatch, getState) => {
        const queriesBody = {
            query: `mutation($o:String!,$u:String!,$f:[Int!]!, $r:[Int!]!){save_worker_association_package(entity:$o,packageId:$u,selectItems:$f, removedItems:$r)}`,
            variables: {
                o: entity,
                u: packageId,
                f: selectItems,
                r: removedItems
            },
        };

        return fetchApi("/graphql", queriesBody, {}, { dispatch, user: getState()?.user });
    };
